import { AxiosError } from 'axios';
import { PUT_ATTACH_FILE_BLACKLIST } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface PutAttachBlacklistFileRequest {
  fileName: string
}

export interface PutAttachBlacklistFileResponse {
  key: string
  presignedUrl: string
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: PutAttachBlacklistFileResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutAttachBlacklistFile = ({ onSuccess, onError }: Input) => {
  const putAttachBlacklistFile = async (payload: PutAttachBlacklistFileRequest) => {
    const res = await axiosClient.put<PutAttachBlacklistFileResponse>(
      PUT_ATTACH_FILE_BLACKLIST,
      {
        fileName: payload.fileName,
      }
    );
    return res.data;
  };

  return useCustomMutation(putAttachBlacklistFile, {
    onSuccess,
    onError,
  });
};
